import { SxProps, Theme } from '@mui/material';

export const styles: Record<'dialog' | 'button' | 'buttonContainer', SxProps<Theme>> = {
  button: {
    width: {
      sm: 576,
      xxs: '100%',
    },
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: (theme) => theme.spacing(1),
    width: '100%',
  },
  dialog: {
    width: {
      sm: 842,
    },
  },
};
